import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import BgImageContent from '../../../layout/BgImageContent';
import { STATIC_IMAGES } from '../../../app.config.vars/staticImages';
import QrCode from '../../../ui/QRcode';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { useTranslation } from 'react-i18next';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Button from '../../../ui/Button';
import ShareIcon from '../../../assets/icons/share.svg';
import CopiedMessage from '../../../ui/CopiedMessage';
const AdminRallyPublishedPage = () => {
    const { id: rallyId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [justCopied, setJustCopied] = useState(false);
    const canvasRef = useRef(null);
    const copyQrToClipboard = async () => {
        if (!canvasRef.current) {
            return;
        }
        canvasRef.current.toBlob(async (blob) => {
            if (!blob) {
                return;
            }
            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        'image/png': blob,
                    }),
                ]);
                setJustCopied(true);
                setTimeout(() => setJustCopied(false), 1500);
            }
            catch (err) {
                console.error('Failed to copy image: ', err);
            }
        });
    };
    return (_jsx(AdminPageLayout, { children: _jsx("div", { className: 'page-content-wrapper published-rally-page', children: _jsx(BgImageContent, { title: t('admin.rally_was_published'), imagePosition: 'bottom center', color: "#327861", imageSrc: localStorage.getItem(STATIC_IMAGES.gameCompleted.key) || undefined, backgroundColor: "#00A19A33", children: _jsxs(_Fragment, { children: [_jsx(QrCode, { url: `${location.origin}/rallies/${rallyId}`, title: "admin.qr_code_for_rally", canvasRef: canvasRef }), _jsxs(ButtonsGroup, { children: [_jsx(Button, { onClick: () => navigate(APP_ROUTES.adminManageRallies), label: t('button.back_to_overview') }), _jsx(Button, { onClick: () => copyQrToClipboard(), label: t('button.share_qr'), icon: _jsx(ShareIcon, {}) }), _jsx(CopiedMessage, { justCopied: justCopied })] })] }) }) }) }));
};
export default AdminRallyPublishedPage;
